import type { Option } from '@/modules/common/types/option.type.ts';
import { RoutePointTypeId } from '@/modules/common/enums/route-point-type-id.enum.ts';
import type { StickerColor } from '@/modules/common/types/sticker-color.type.ts';

export interface RoutePointTypeOption extends Option<RoutePointTypeId> {
  color: StickerColor;
}

export const ROUTE_POINT_TYPES: Record<RoutePointTypeId, RoutePointTypeOption> = {
  [RoutePointTypeId.Assignment]: {
    code: RoutePointTypeId.Assignment,
    label: 'common.shared.assignment',
    color: 'green',
  },
  [RoutePointTypeId.Agreement]: {
    code: RoutePointTypeId.Agreement,
    label: 'common.shared.agreement',
    color: 'blue',
  },
  [RoutePointTypeId.Notification]: {
    code: RoutePointTypeId.Notification,
    label: 'common.shared.notification',
    color: 'light-blue',
  },
};

export const ROUTE_POINT_TYPES_OPTIONS = Object.values(ROUTE_POINT_TYPES);
